import FeedbackModal from './FeedbackModal'
import ErrorModal from './ErrorModal'

export { ErrorModal, FeedbackModal }



// WEBPACK FOOTER //
// ./src/app/components/common/feedbackModal/index.js